import { render, staticRenderFns } from "./examen-clinique.html?vue&type=template&id=4b739df9&scoped=true&external"
import script from "./examen-clinique.js?vue&type=script&lang=js&external"
export * from "./examen-clinique.js?vue&type=script&lang=js&external"
import style0 from "./examen-clinique.scss?vue&type=style&index=0&id=4b739df9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b739df9",
  null
  
)

export default component.exports